import { useState } from "react";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import DownloadIcon from "@mui/icons-material/Download";
import ArticleOutlinedIcon from "@mui/icons-material/ArticleOutlined";
import ImageOutlinedIcon from "@mui/icons-material/ImageOutlined";

export default function GraphDownloadButton({ onDownloadCsv, onDownloadPng }) {
  const [anchorEl, setAnchorEl] = useState(null);

  const tzLabel = "SAST timestamps";

  const close = () => setAnchorEl(null);

  return (
    <>
      <IconButton
        size="small"
        onClick={(e) => setAnchorEl(e.currentTarget)}
        sx={{
          color: "rgba(255,255,255,0.45)",
          flexShrink: 0,
          "&:hover": {
            color: "#FDB940",
            backgroundColor: "rgba(253,185,64,0.08)",
          },
        }}
      >
        <DownloadIcon sx={{ fontSize: 16 }} />
      </IconButton>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={close}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
        PaperProps={{
          sx: {
            mt: "6px",
            backgroundColor: "#1C232C",
            border: "1px solid rgba(255,255,255,0.12)",
            borderRadius: "10px",
            minWidth: 210,
            boxShadow: "0 8px 24px rgba(0,0,0,0.5)",
          },
        }}
      >
        <MenuItem
          onClick={() => { onDownloadCsv?.(); close(); }}
          sx={{ gap: "10px", py: "10px", px: "14px", "&:hover": { backgroundColor: "rgba(255,255,255,0.06)" } }}
        >
          <ListItemIcon sx={{ minWidth: "auto" }}>
            <ArticleOutlinedIcon sx={{ color: "rgba(255,255,255,0.55)", fontSize: 20 }} />
          </ListItemIcon>
          <Box>
            <Typography sx={{ color: "#fff", fontSize: "0.88rem", fontWeight: 500, lineHeight: 1.3 }}>
              Download CSV
            </Typography>
            <Typography sx={{ color: "rgba(255,255,255,0.38)", fontSize: "0.7rem", mt: "1px" }}>
              {tzLabel}
            </Typography>
          </Box>
        </MenuItem>

        <MenuItem
          onClick={() => { onDownloadPng?.(); close(); }}
          sx={{ gap: "10px", py: "10px", px: "14px", "&:hover": { backgroundColor: "rgba(255,255,255,0.06)" } }}
        >
          <ListItemIcon sx={{ minWidth: "auto" }}>
            <ImageOutlinedIcon sx={{ color: "rgba(255,255,255,0.55)", fontSize: 20 }} />
          </ListItemIcon>
          <Typography sx={{ color: "#fff", fontSize: "0.88rem", fontWeight: 500 }}>
            Download PNG
          </Typography>
        </MenuItem>
      </Menu>
    </>
  );
}
